import { render } from "./HomePart2.vue?vue&type=template&id=62bdbc98&scoped=true&ts=true"
import script from "./HomePart2.vue?vue&type=script&lang=ts"
export * from "./HomePart2.vue?vue&type=script&lang=ts"

import "./HomePart2.vue?vue&type=style&index=0&id=62bdbc98&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62bdbc98"]])

export default __exports__